($ => {
  $(document).ready(() => {
    $('.dumel-product-list__items').each((idx, productsList) => {
      const template = `
        <li class="dumel-product-list__item">
          <a href="products/#:data.ProductUrl#">
            <div class="dumel-product-list__image-wrapper">
              <div class="dumel-product-list__image" style="background-image: url(/image/#:data.RelatedPicture#/250)"></div>
            </div>
            <p class="dumel-product-list__title">#:data.ProductName#</p>
            <p class="dumel-product-list__sub-title">
            #if(data.categories.length){#
            #:data.categories[0].ContentTitle#
            #}#
            </p>
          </a>
        </li>
          `;
      const token = $('meta[name="csrf-token"]').attr('content');
      const datasetProduct = new novaCmsDataSets.ProductDataSet(token);
      const filterResult = {
        filtered: 0,
        total: 0
      };
      productsList.addEventListener('OnDumelFiltersChange', (e: CustomEvent) => {
        filterProducts();
      }, false);
      getProducts();
      filterProducts();
      datasetProduct.dataSource.bind('change', e => {
        filterResult.filtered = datasetProduct.dataSource.total();

        const onDumelProductListChange = new CustomEvent('OnDumelProductListChange', { detail: filterResult });

        productsList.dispatchEvent(onDumelProductListChange);
      });

      function getProducts() {
        $(productsList).kendoListView({
          dataSource: datasetProduct.dataSource,
          template: kendo.template(template, { useWithBlock: false }),
          dataBound: data => {
            filterResult.total = datasetProduct.dataSource.data().length;
            const filterProductsIds = datasetProduct.dataSource.view().map(prod => {
              const product = (prod as any);
              const productId = product.id;

              return {
                productId,
                url: product.ProductUrl
              };
            });
            sessionStorage.setItem('filterProductsIds', JSON.stringify(filterProductsIds));
          }
        });
      }

      function filterProducts() {
        const filtersModel: kendo.data.DataSourceFilterItem[] = $(productsList).data('ProductsFiltersModel');
        datasetProduct.dataSource.filter(filtersModel);
      }
    });
  });
})(jQuery);
